// @ts-nocheck

import json from './Shoe.json';
import image from './Shoe.png';

import atlas from '!!raw-loader!./Shoe.atlas';

export default {
  id: 'Shoe',
  atlas,
  images: {
    'Shoe.png': image,
  },
  json,
  isLoop: true,
};
